/* eslint-disable no-console */
import {
  BUSINESS_SOLUTION_ORGANIZATION_ID,
  GRUSHKA_ORGANIZATION_ID,
} from '@app/access/constants/organizations';
import { config } from '@app/config';

type ConsoleMethod = 'log' | 'warn' | 'error' | 'info' | 'debug';

export const clogLeadsRegistryDebug = (
  database: string | null,
  ...args: unknown[]
) => {
  const isAllowedOrganization =
    database === GRUSHKA_ORGANIZATION_ID ||
    database === BUSINESS_SOLUTION_ORGANIZATION_ID;

  if (config.mode === 'production' && !isAllowedOrganization) {
    return;
  }

  console.log(...args);
};

export const clog = (...args: unknown[]) => {
  // Проверяем, является ли первый аргумент строкой и соответствует ли он одному из методов консоли
  if (
    typeof args[0] === 'string' &&
    ['log', 'warn', 'error', 'info', 'debug'].includes(args[0])
  ) {
    const [type, ...data] = args;
    if (config.showConsoleLogs) {
      console[type as ConsoleMethod](...data);
    }
  } else {
    // Если первый аргумент не тип, то используем console.log для всех аргументов
    if (config.showConsoleLogs) {
      console.log(...args);
    }
  }
};
